(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    function placeUsecaseArticleTagList() {
    const root = document.querySelector('.blog-post-content');
    if (!root) return;

    const tagList = root.querySelector('.usecase-article-tag-list');
    if (!tagList) return;

    const container = root.querySelector('.container');
    if (container && container.parentNode) {
      container.parentNode.insertBefore(tagList, container);
    }

    tagList.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeUsecaseArticleTagList);
  } else {
    placeUsecaseArticleTagList();
  }
  } catch(e) { console.error(e); }
})();

})();
